<template>
  <div>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">
          Recherche de compétences
        </p>
        <p class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 max-w-3/4 2xl:max-w-11/12">
          Vous pouvez rechercher une compétence personnelle, socio-professionnelle ou professionnelle sur l’ensemble des passeports.
        </p>
      </div>
      <illustration
        name="fiche_de_poste"
        class="hidden xl:block absolute right-5 xl:right-10 -top-8 w-60 xl:w-72"
      />
    </div>

    <div class="mt-15 align-middle shadow rounded-lg border-b border-gray-200 bg-white pb-10 min-h-halfscreen max-w-full">
      <router-view v-if="allowed" />
      <page-not-allowed v-if="!allowed" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Illustration from './../../components/Illustration.vue';
import PageNotAllowed from './../../components/PageNotAllowed.vue';
export default {
  components:{
    Illustration,
    PageNotAllowed,
  },
  name: 'RechercheLayout',

  computed:{
    ...mapGetters({
      allowed: 'app/allowed',
    }),
  }
};
</script>
